import React from "react";

export const Family = () => (
  <div>
    <div id="container">
      <h1>Family</h1>
      <p>This is your family</p>
      <h2>Father</h2>
      <h2>Mother</h2>
      <h2>Older Sister</h2>
      <h2>Younger Sister</h2>
      <h2>Older Brother</h2>
      <h2>Yonger Brother</h2>
    </div>
  </div>
);
